export enum ConfigUrlsTypes {
  FhirBaseApiUrl = "FHIR_BASE_API_URL",
}

export enum AuthValues {
  authType = "auth_type",
  bearerToken = "bearer_token",
  accessTokenUrl = "access_token_url",
  clientId = "client_id",
  clientSecret = "client_secret",
  scope = "scope",
  grantType = "grant_type",
  accessToken = "access_token",
}

export enum AuthConfigTypeValues {
  NoAuth = "noAuth",
  BearerToken = "bearerToken",
  OAuth2 = "OAuth2",
}
